import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { type AudioSlice, createAudioSlice } from '@/shared/lib/audio';
import { createDialogSlice, type DialogSlice } from '@/shared/lib/dialog';
import { createLocaleSlice, type LocaleSlice } from '@/shared/lib/i18n';
import { createLayoutSlice, type LayoutSlice } from '@/shared/lib/layout';

export type UiStoreState = LocaleSlice & AudioSlice & LayoutSlice & DialogSlice;

export const useUiStore = create<UiStoreState>()(
  subscribeWithSelector(
    immer((...a) => ({
      ...createLocaleSlice(...a),
      ...createAudioSlice(...a),
      ...createLayoutSlice(...a),
      ...createDialogSlice(...a),
    })),
  ),
);
